export const MaybernTableSizes = {
  headerHeight: 56,
  groupHeaderHeight: 35,
  rowHeight: 42,
  paginationRowHeight: 36,
};
